// extracted by mini-css-extract-plugin
export default {"root":"BackOfficeHeader_root__NjGJh","main":"BackOfficeHeader_main__bUT7z","actions":"BackOfficeHeader_actions__dyqmj","popOverButton":"BackOfficeHeader_popOverButton__RrfK-"};